<ng-continer *ngIf="!moveToAddModule" >
    <div class="topHead">
        <a href="javascript:void(0);" class="adminBack" [routerLink]="['/authoring_list']"
            [queryParams]="{tab: tab}"><img src="assets/images/admin/backarrow.png" /> Back to Content Authoring</a>
        <!-- <div class="logout">
            <b>{{adminData.first_name+" " + adminData.last_name}}</b>
            <a href="javascript:void(0);" (click)="logout()"><img src="assets/images/admin/power.png" /> </a>
        </div> -->
        <div class="logout">
            <app-log-out class="logout"></app-log-out>
        </div>
    </div>

    <div class="formHeading pr-0">
        <div class="row m-0">
            <div class="col-12 col-md-6">
                <h2 *ngIf="(capsuleId && tab) || (!capsuleId && !tab)">Create Content Capsule</h2>
                <h2 *ngIf="capsuleId && !tab">Edit Content Capsule</h2>
                <p *ngIf="(capsuleId && tab) || (!capsuleId && !tab)">Please add the following information to create a
                    new content capsule</p>
                <p *ngIf="capsuleId && !tab">Please add the following information to edit content capsule</p>
            </div>
        </div>
    </div>
    <ngx-spinner>
        <p style="color: white"> Loading... </p>
    </ngx-spinner>
    <form [formGroup]="contentAuthForm">
        <div class="sttperWrap pt-1 mb-4">
            <div class="sttperBody sttperContentBody mt-5">
                <div class="row m-0">
                    <div class="col-8">
                        <div class="commanInput">
                            <mat-form-field class="example-full-width">
                                <mat-label>capsule Name</mat-label>
                                <input matInput #capsuleName maxlength="50" placeholder="Enter Name"
                                    formControlName="capsule_name"
                                    [ngClass]="{ 'is-invalid': submitted && f.capsule_name.errors }">
                                <mat-hint align="end">{{capsuleName.value.length}} / 50 characters</mat-hint>
                            </mat-form-field>
                        </div>
                        <div *ngIf="submitted && f.capsule_name.errors">
                            <span *ngIf="f.capsule_name.errors.required" class="text-mute text-danger errorText">This
                                field is required</span>
                            <span *ngIf="f.capsule_name.errors.cannotContainSpace"
                                class="text-mute text-danger errorText">CapsuleName can not contain space.</span>
                        </div>
                    </div>
                    <div class="col-4 p-0">
                        <span class="inputTitle">For Internal reference only</span>
                    </div>
                </div>

                <div>
                    <div class="questionDropWrap" formArrayName="contentCapsuleMedia" class="example-list">

                        <!-- <div class="addQuestions mb-3">Add Text</div> -->
                        
                        <div *ngFor="let itemrow of formArr.controls; index as i">
                            <div [formGroupName]="i">
                                <div class="addvideoWrap border-top" *ngIf="text[i] > 0">
                                    <ngb-accordion #a="ngbAccordion" activeIds="custom-panel-1">
                                        <ngb-panel id="custom-panel-1">
                                            <ng-template ngbPanelHeader let-opened="opened">
                                                <div class="add_QuestionsHeading">
                                                    <!-- <b><img src="assets/images/admin/drog.png" /></b> -->
                                                    <!-- <span>Add Text</span> -->
                                                    <div class="removePosition" (click)="deleteRow(i)"
                                                        style="margin-right: 0%;">
                                                        <a href="javascript:void(0);" class="btn-remove"><img
                                                                src="assets/images/admin/delete.svg" />Remove</a>
                                                    </div>
                                                    <!-- <button class="ml-auto" ngbPanelToggle><img
                                                            src="assets/images/admin/dropdown.png" /></button> -->
                                                </div>
                                            </ng-template>
                                            <ng-template ngbPanelContent>
                                                <div class="row m-0">
                                                    <div class="col-12">
                                                        <div class="commanInput commanTextarea">
                                                            <div class="closeIcon"></div>
                                                            <div class="titleDis">Add Text</div>
                                                            <ckeditor tagName="textarea" formControlName="media_content" (blur)="saveChangedValue()"
                                                                placeholder="Enter Description"
                                                                [config]="{ toolbar: [ [ 'Bold', 'Italic', 'NumberedList', 'Strike', 'BulletedList', 'Format'], ['Table']] }">
                                                            </ckeditor>
                                                            <!-- <mat-form-field class="example-full-width">
                                                                <mat-label>Add Text</mat-label>
                                                                <textarea matInput placeholder="Enter Description"
                                                                    formControlName="media_content"></textarea>
                                                            </mat-form-field> -->
                                                        </div>
                                                        <div *ngIf="itemrow.touched && itemrow.invalid">
                                                            <span *ngIf="itemrow.hasError('required','media_content')"
                                                                class="text-mute text-danger errorText">This field is
                                                                required</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </ng-template>
                                        </ngb-panel>
                                    </ngb-accordion>
                                </div>
                                <div class="addvideoWrap" *ngIf="video[i] > 0">
                                    <div class="removePosition" (click)="deleteRow(i)">
                                        <a href="javascript:void(0);" class="btn-remove"><img
                                                src="assets/images/admin/delete.svg" />Remove</a>
                                    </div>
                                    <p class="titleDis">Add video</p>
                                    <div class="videoUrlWrap" *ngIf="(fileName && fileName[i]!='' && imageSrc[i])">
                                        <b (click)="removeImage(i)"><img
                                                src="assets/images/admin/plus_circle.svg" /></b>
                                                <video controls="true"  controlsList="nodownload" oncontextmenu="return false;">
                                                    <source src={{imageSrc[i]}} type="video/mp4">
                                                    Sorry, your browser doesn't support embedded videos.
                                                </video>
                                    </div>
                                    <div class="videoUploadInput" *ngIf="!imageSrc[i]">
                                        <div class="videoUpload">
                                            <input type="file" (change)="onFileChange($event,i,'video')"
                                                accept="video/mp4" />
                                            <div class="videoUploadIcon">
                                                <figure><img src="assets/images/admin/inputUpload.png" /></figure>
                                                <b>Drag and drop or browse files</b>
                                            </div>
                                        </div>
                                        <p>Max size: 200 MB</p>
                                    </div>
                                    <div *ngIf="itemrow.touched && itemrow.invalid">
                                        <span *ngIf="itemrow.hasError('required','media_path')"
                                            class="text-mute text-danger errorText">This field is required</span>
                                    </div>
                                    <div class="viewUploadWrap" *ngIf="video[i]>0">
                                        <div class="viewUpload">
                                            <figure *ngIf="imageSrc[i]">
                                                <span href="javascript:void(0);" *ngIf="(fileName && submitted)"><img
                                                        src="assets/images/admin/plus_circle.svg" /></span>
                                            </figure>
                                            <div class="form-group" *ngIf="imageError[i] && imageError[i]!=''">
                                                <div><span class="text-mute text-danger errorText">{{
                                                        imageError[i]}}</span></div>
                                            </div>
                                            <div class="blueUploadWrap">
                                                <b class="name">{{fileName[i]}}</b>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row m-0 mt-4">
                                        <div class="col-12">
                                            <div class="commanInput">
                                                <mat-form-field class="example-full-width">
                                                    <mat-label>Title</mat-label>
                                                    <input matInput #mediaTitle maxlength="50" placeholder="Enter Title"
                                                        formControlName="media_title">
                                                    <mat-hint align="end">{{mediaTitle.value.length}} / 50 characters
                                                    </mat-hint>
                                                </mat-form-field>
                                            </div>
                                        </div>

                                         <!-- new Field added in Title of video Milan -->
                                        <div class="col-12">
                                            <div class="commanInput">
                                                <mat-form-field class="example-full-width">
                                                    <mat-label>Video Title</mat-label>
                                                    <input matInput #mediaTitle1 maxlength="50" placeholder="Enter Video Title"
                                                        formControlName="media_img_video_title">
                                                    <mat-hint align="end">{{mediaTitle1.value.length}} / 50 characters
                                                    </mat-hint>
                                                </mat-form-field>
                                            </div>
                                        </div>
                                        <div class="col-12">
                                            <div class="commanInput commanTextarea">
                                                <div class="closeIcon"></div>
                                                <div class="titleDis">Description</div>
                                                <ckeditor tagName="textarea" formControlName="media_content"
                                                    placeholder="Enter Description"
                                                    [config]="{ toolbar: [ [ 'Bold', 'Italic', 'NumberedList', 'Strike', 'BulletedList', 'Format'], ['Table']] }">
                                                </ckeditor>
                                                <!-- <mat-form-field class="example-full-width">
                                                    <mat-label>Description</mat-label>
                                                    <textarea matInput placeholder="Enter Description"
                                                        formControlName="media_content"></textarea>
                                                </mat-form-field> -->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="addvideoWrap" *ngIf="image[i] > 0">
                                    <div class="removePosition" (click)="deleteRow(i)">
                                        <a href="javascript:void(0);" class="btn-remove"><img
                                                src="assets/images/admin/delete.svg" />Remove</a>
                                    </div>
                                    <p class="titleDis">Add Image</p>
                                    <div class="videoUploadInput" *ngIf="!imageSrc[i]">
                                        <div class="videoUpload">
                                            <input type="file" (change)="onFileChange($event,i,'image');"
                                                accept="image/x-png,image/gif,image/jpeg" />
                                            <div class="videoUploadIcon">
                                                <figure><img src="assets/images/admin/inputUpload.png" /></figure>
                                                <b>Drag and drop or browse files</b>
                                            </div>
                                        </div>
                                        <p>Max size: 5 MB</p>
                                    </div>
                                    <div *ngIf="itemrow.touched && itemrow.invalid">
                                        <span *ngIf="itemrow.hasError('required','media_path')"
                                            class="text-mute text-danger errorText">This field is required</span>
                                    </div>
                                    <div class="viewUploadWrap">
                                        <div class="viewUpload">
                                            <figure *ngIf="imageSrc[i]">
                                                <span (click)="removeImage(i)">
                                                    <img
                                                        src="assets/images/admin/plus_circle.svg" />
                                                    </span>
                                                <img [src]="imageSrc[i]" class="mw-100" />
                                            </figure>
                                            <div class="blueUploadWrap" *ngIf="imageSrc[i]">
                                                <b class="name">{{fileName[i]}}</b>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row m-0 mt-4">
                                        <div class="col-12">
                                            <div class="commanInput">
                                                <mat-form-field class="example-full-width">
                                                    <mat-label>Title</mat-label>
                                                    <input matInput #mediaTitle maxlength="50" placeholder="Enter Title"
                                                        formControlName="media_title" (change)="saveChangedValue()">
                                                    <mat-hint align="end">{{mediaTitle.value.length}} / 50 characters
                                                    </mat-hint>
                                                </mat-form-field>
                                            </div>
                                        </div>

                                        <!-- new Field added in Title of image Milan -->
                                        <div class="col-12">
                                            <div class="commanInput">
                                                <mat-form-field class="example-full-width">
                                                    <mat-label>Image Title</mat-label>
                                                    <input matInput #mediaTitle2 maxlength="50" placeholder="Enter Image Title"
                                                        formControlName="media_img_video_title" (change)="saveChangedValue()">
                                                    <mat-hint align="end">{{mediaTitle2.value.length}} / 50 characters
                                                    </mat-hint>
                                                </mat-form-field>
                                            </div>
                                        </div>

                                        <div class="col-12">
                                            <div class="commanInput commanTextarea">
                                                <div class="closeIcon"></div>
                                                <div class="titleDis">Description</div>
                                                <ckeditor tagName="textarea" formControlName="media_content"
                                                    placeholder="Enter Description"
                                                    [config]="{ toolbar: [ [ 'Bold', 'Italic', 'NumberedList', 'Strike', 'BulletedList', 'Format'], ['Table']] }">
                                                </ckeditor>
                                                <!-- <mat-form-field class="example-full-width">
                                                    <mat-label>Description</mat-label>
                                                    <textarea matInput placeholder="Enter Description"
                                                        formControlName="media_content"></textarea>
                                                </mat-form-field> -->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <hr />
                <div class="addTags" [ngClass]="capsuleName.value.length < 1? 'addTags disable' : 'addTags'">
                    <span class="active " (click)="addNewText()">+ add Text</span>
                    <span class="active" (click)="addNewVideo()">+ add video</span>
                    <span class="active" (click)="addNewImage()">+ add image</span>
                    <!-- <span class="active" (click)="addNewMore()">+ add more</span> -->
                </div>
                <div class="ml-auto position-relative" *ngIf="assessment_id">
                    <a href="javascript:void(0);" class="btn-link text-uppercase ml-1 mr-1"
                        (click)="editAssesment()"><span>View/Edit Assessment</span></a>
                    <div class="removePosition" (click)="open(deleteModle)">
                        <a href="javascript:void(0);" class="btn-remove"><img
                                src="assets/images/admin/delete.svg" />Remove</a>
                    </div>
                </div>
            </div>
            <div class="sttperFooter">
                <div class="row m-0">
                    <a href="javascript:void(0);" class="backPage ml-2 mr-2" (click)="open(cancelModle)">Cancel</a>
                    <a href="javascript:void(0);" class="backPage ml-2 mr-2" (click)="open(resetModle)">Reset</a>
                    <div class="ml-auto">
                        <a href="javascript:void(0);" class="btn btn-primary btn-sm btn-border ml-1 mr-1" (click)="open(re_order)"
                            [ngClass]="(capsuleName.value.length < 1 || countformArr < 1) ? 'btn btn-primary btn-sm btn-border ml-1 mr-1 disableborder ' : 'btn btn-primary btn-sm btn-border ml-1 mr-1'">
                            <img src="assets/images/icons/reorder.png" class="d-inline-block" /> ReORDER</a>
                        <!-- <a href="javascript:void(0);" class="btn btn-primary btn-sm btn-border ml-1 mr-1"
                            *ngIf="!assessment_id"
                            [ngClass]="(capsuleName.value.length < 1 || countformArr < 1) ? 'btn btn-primary btn-sm btn-border ml-1 mr-1 disableborder ' : 'btn btn-primary btn-sm btn-border ml-1 mr-1'"
                            (click)="addAssesment()"><span>Add Assessment</span></a> -->

                            <!-- new added visiblae the add assessment Milan -->
                        <a href="javascript:void(0);" class="btn btn-primary btn-sm btn-border ml-1 mr-1"
                            *ngIf="!assessment_id"
                            [ngClass]="(capsuleName.value.length < 1) ? 'btn btn-primary btn-sm btn-border ml-1 mr-1 disableborder ' : 'btn btn-primary btn-sm btn-border ml-1 mr-1'"
                            (click)="addAssesment()"><span>Add Assessment</span></a>

                            <!-- new added visiblae the prview Milan -->
                        <a href="javascript:void(0);" *ngIf="(tab && capsuleId) || (!capsuleId && !tab)"
                            (click)="saveContentAuth('1',3)"
                            [ngClass]="(capsuleName.value.length < 1) ? 'btn btn-primary btn-sm btn-border ml-1 mr-1 disableborder ' : 'btn btn-primary btn-sm btn-border ml-1 mr-1' "><span>Preview</span></a>
                        
                        <!-- <a href="javascript:void(0);" *ngIf="(tab && capsuleId) || (!capsuleId && !tab)"
                            (click)="saveContentAuth('1',3)"
                            [ngClass]="(capsuleName.value.length < 1 || countformArr < 1) ? 'btn btn-primary btn-sm btn-border ml-1 mr-1 disableborder ' : 'btn btn-primary btn-sm btn-border ml-1 mr-1' "><span>Preview</span></a> -->
                        
                        <a href="javascript:void(0);" *ngIf="(tab && capsuleId) || (!capsuleId && !tab)"
                            [ngClass]=" (capsuleName.value.length < 1) ? 'btn btn-primary btn-sm btn-border ml-1 mr-1 disableborder ' : 'btn btn-primary btn-sm btn-border ml-1 mr-1' "
                            (click)="saveContentAuth('1',2)"><span>Save as Draft</span></a>
                        <a href="javascript:void(0);"
                            [ngClass]="(capsuleName.value.length < 1 || countformArr < 1) ? 'btn btn-primary btn-sm ml-2 mr-2 disable ' : 'btn btn-primary btn-sm ml-2 mr-2' "
                            (click)="saveContentAuth('2',0)">Save content capsule</a>
                    </div>
                </div>
            </div>
            
            <input type="hidden" (click)="open(imgValidat)" id="errorImg">
        </div>
    </form>
</ng-continer>

<!--assessment delete modal-->
<ng-template #deleteModle let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
            <div *ngIf="activeDleMod">
                <h6>Delete Assessment</h6>
                <p class="size18">Are you sure you would like to delete this assessment?</p>
                <input type="hidden" (click)="modal.dismiss('Cross click')" id="cancelId">
                <a href="javascript:void(0);" (click)="modal.dismiss('Cross click')"
                    class="backPage ml-2 mr-2">Cancel</a>
                <a href="javascript:void(0);" (click)="deleteAssessment(assessment_id)"
                    class="btn btn-primary btn-sm">Confirm</a>
            </div>
            <!-- <div *ngIf="succesDelAssessment">
                <figure><img src="assets/images/admin/circle_check.png" /></figure>
                <p class="size18">You have successfully activated the course.<br />
                    You can now assign users!</p>
                <a href="javascript:void(0);" class="backPage ml-2 mr-2"
                    (click)="modal.dismiss('Cross click')">Close</a>
                <a href="javascript:void(0);" class="btn btn-primary btn-sm" (click)="modal.dismiss('Cross click')">Assign Users now</a>
            </div> -->

        </div>
    </div>
</ng-template>
<!--cancle capsule model-->
<ng-template #cancelModle let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
            <div *ngIf="activeDleMod">
                <h6>Cancel Content Authoring</h6>
                <p class="size18">Are you sure you would like to Cancel this Content Authoring?</p>
                <input type="hidden" (click)="modal.dismiss('Cross click')" id="cancelId">
                <a href="javascript:void(0);" (click)="modal.dismiss('Cross click')"
                    class="backPage ml-2 mr-2">Cancel</a>
                <a href="javascript:void(0);" (click)="cancleCapsule()" class="btn btn-primary btn-sm">Confirm</a>
            </div>
        </div>
    </div>
</ng-template>
<!--reset capsule model-->
<ng-template #resetModle let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
            <div *ngIf="activeDleMod">
                <h6>Reset Content Authoring</h6>
                <p class="size18">Are you sure you would like to Reset this Content Authoring?</p>
                <input type="hidden" (click)="modal.dismiss('Cross click')" id="resetId">
                <a href="javascript:void(0);" (click)="modal.dismiss('Cross click')"
                    class="backPage ml-2 mr-2">Cancel</a>
                <a href="javascript:void(0);" (click)="reseContentAuthForm()" class="btn btn-primary btn-sm">Confirm</a>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #imgValidat let-modal>
    <div class="modal-body" *ngIf="activeCanMod">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
            <div>
                <!-- <h6>Reset Assessment</h6> -->
                <p class="size18">{{errorMsgImgSize}}</p>
                <input type="hidden" (click)="modal.dismiss('Save click')" id="CloseIds">
                <a href="javascript:void(0);" (click)="modal.dismiss('Cross click')"
                    class="backPage ml-2 mr-2">Cancel</a>
                <!-- <a href="javascript:void(0);" (click)="resetAssForm()" class="btn btn-primary btn-sm">Confirm</a> -->
            </div>
        </div>
    </div>
</ng-template>
<!--reset capsule model-->
<ng-template #re_order let-modal>
    <div class="modal-body">
       
            <div class="holdPopup text-center">
                <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                    <span aria-hidden="true">&times;</span>
                </button>
                <div *ngIf="activeDleMod">
                    <h6>REORDER</h6>
                    <p class="size18">Please drag and drop the content type to change the order.</p>
                    <div class="tablePopupWrap">
                        <table>
                            <thead>
                                <tr>
                                    <th>CURRENT</th>
                                    <th>MEDIA NAME</th>
                                </tr>
                            </thead>
                            <tbody cdkDropList class="example-list" (cdkDropListDropped)="drop($event)">
                                <tr cdkDrag *ngFor="let itemrow of formArr.controls; index as i">
                                    <td>
                                        <div class="td_wrap">{{i+1}}.</div>
                                        <input type="hidden" value={{i}} class="feildInput" />
                                    </td>
                                    <td>
                                        <div class="td_wrap" *ngIf="text[i] > 0"><span [innerHtml]="(formArr.controls[i].value['media_content'].length>20)? (formArr.controls[i].value['media_content'] | slice:0:20)+'........':(formArr.controls[i].value['media_content'])">{{ (formArr.controls[i].value['media_content'].length>20)? (formArr.controls[i].value['media_content'] | slice:0:20)+'........':(formArr.controls[i].value['media_content']) }}</span></div>
                                        <div class="td_wrap" *ngIf="video[i] > 0"><span *ngIf="!fileName[i]">Video</span><span *ngIf="fileName[i]">{{fileName[i]}}</span></div>
                                        <div class="td_wrap" *ngIf="image[i] > 0"><span *ngIf="!fileName[i]">Image</span><span *ngIf="fileName[i]">{{fileName[i]}}</span></div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
    </div>
</ng-template>

<app-add-authoring-assessment *ngIf="moveToAddModule" (finalSubmit)="retFromAddAss($event)" [assData]="assessment_id">
</app-add-authoring-assessment>